
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/compare/chatbase",
      function () {
        return require("private-next-pages/compare/chatbase.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/compare/chatbase"])
      });
    }
  